import { render, staticRenderFns } from "./NicknameCard.vue?vue&type=template&id=0afc01bf"
import script from "./NicknameCard.js?vue&type=script&lang=js&external"
export * from "./NicknameCard.js?vue&type=script&lang=js&external"
import style0 from "./NicknameCard.vue?vue&type=style&index=0&id=0afc01bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports